var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:('email@example.com'),expression:"'email@example.com'"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"email@example.com"},domProps:{"value":_vm.formattedValue},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }